export { default } from './TabGroupSeguros';
